export const ErrorCodes = {
    tag: { code: "E4101", name: "Tag", message: "Tag is not provided" },
    tagNotFound: { code: "E4102", name: "Tag", message: "Tag not found" },
    QuoteFailed: { code: "E4103", name: "QuoteFailed", message: "Quote Failed" },
    sdkFailed: { code: "E4104", name: "sdk error", message: "something went wrong" },
};
